import React from 'react'
import {Table, Thead, Tbody, Tr, Th, Td, TableContainer} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import PropTypes from 'prop-types'

const StoreHoursTable = ({hoursOnline, hoursDefault, hoursRows, hoursName}) => {
    const intl = useIntl()

    if (!hoursOnline || !hoursDefault || !hoursRows || hoursRows.length === 0) {
        return null
    }

    return (
        <TableContainer>
            <Table variant="simple">
                <Thead>
                    <Tr>
                        <Th>
                            {intl.formatMessage(
                                {
                                    id: 'plp.storeSelector.stores.time.hours_name',
                                    defaultMessage: '{hrsName}'
                                },
                                {hrsName: hoursName}
                            )}
                        </Th>
                        <Th>
                            {intl.formatMessage({
                                id: 'plp.storeSelector.stores.time.open',
                                defaultMessage: 'Open'
                            })}
                        </Th>
                        <Th>
                            {intl.formatMessage({
                                id: 'plp.storeSelector.stores.time.close',
                                defaultMessage: 'Close'
                            })}
                        </Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {hoursRows?.map((item, index) => (
                        <Tr key={index}>
                            <Td>{item?.split('|')[0]?.trim()}</Td>
                            <Td>{item?.split('|')[1]?.trim()}</Td>
                            <Td>{item?.split('|')[2]?.trim()}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </TableContainer>
    )
}

StoreHoursTable.propTypes = {
    hoursOnline: PropTypes.bool.isRequired,
    hoursDefault: PropTypes.any,
    hoursName: PropTypes.string,
    hoursRows: PropTypes.arrayOf(PropTypes.string)
}

export default StoreHoursTable
